<template>
<div>
    <transition name="fade">
            <div v-if="performingRequest" class="loading">
                <p>Loading messages...</p>
            </div>
        </transition>
    <b-container fluid>
    <div class="container-fluid" style="overflow: hidden">
        <div class="row">
            <div class='col-12'>
            <h2>Conversations</h2>
                    <table class='table table-hover'>
                        <tbody>
                            <tr v-for="(item) in userMessagesArray" :key="item.senderId"  @click="showMessageDetails(item.messages,item.messageinfo, item.unreadByUser)" style='cursor: pointer'>
                            <!-- Green background if unread -->
                                <div v-if="item.unreadByUser" class="bg-success"> 
                                    <td><h5 class="text-white">{{item.conversationWith}}</h5></td>
                                </div>
                                <!-- White background if read -->
                                <div v-else> 
                                    <td><h5>{{item.conversationWith}}</h5></td>
                                </div>

                                <td v-if="item.unreadByUser" class="bg-success" style='color:white'>{{item.messageinfo.lastMessage}}</td>
                                <td v-else>{{item.messageinfo.lastMessage}}</td>


                                <td v-if="item.unreadByUser" class="bg-success" style='color:white'><small>{{item.date}}</small></td>
                                <td v-else><small>{{item.date}}</small></td>
                            </tr>
                        </tbody>

                </table>


            </div>
        </div>
    </div>
    </b-container>
    <footer><pagefooter/></footer>

  </div>
</template>

<script>
/*
module.exports = {
  props: ['personName']
}*/

    import { mapState } from 'vuex'
    import { currentUser, zipcodesCollection } from '../firebaseConfig'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')
    import firebase from 'firebase/app';
    import Pagefooter from './Pagefooter'

export default {
    name: "MessagesVue",
            data() {
            return {
                showSuccess: false,
                theMessage:'',
                messagesArray:[],
                theMessage:'',
                originalMessageObject:{},
                performingRequest:false,
                showingThread:false
            }
        },
        components: {
            Pagefooter,
        },

        computed: {
            ...mapState(['userProfile', 'currentUser', 'userMessagesArray', 
            'isBrewer', 'singleMessageThread', 'activeMessageThreadInfo', 'unreadCount'])
        },
        methods:{
            showMessageDetails(theMessageArray, theMessageInfoObject,unreadByUser){

                //If unread, reduce unread count:
                if(unreadByUser&&this.unreadCount>0)
                    this.$store.commit('setUnreadCount', this.unreadCount-1)
                
                //Set current thread to be active thread
                this.showingThread = true
                this.$store.commit('setActiveMessageThreadInfo', theMessageInfoObject)
                //Get the thread
                this.$store.dispatch('getSingleMessageThread', theMessageInfoObject.id)
                //Set message as read if it was unread by this user
                if(unreadByUser){
                    var theDocId
                    if (theMessageInfoObject.pubId<theMessageInfoObject.brewerId) theDocId = theMessageInfoObject.pubId + theMessageInfoObject.brewerId
                    else theDocId = theMessageInfoObject.brewerId + theMessageInfoObject.pubId

                    fb.messagesCollection.doc(theDocId).update({ "messageinfo.readByReceiver": 1})
                }

                this.$router.push('/singlemessagethreadholder')
            },
        },
                       
        mounted(){
            //Set unread count to 0 once mounted
            //this.$store.commit('setUnreadCount', 0)
        }
}

</script>

<style scoped>
  h2 {
    font-size: 40px;
    color: mediumseagreen;
  }

  .chatcolumn {
    position: absolute;
    overflow-y: scroll;
}
</style>